import script from "./DefPhone.vue?vue&type=script&lang=ts&setup=true"
export * from "./DefPhone.vue?vue&type=script&lang=ts&setup=true"

import "./DefPhone.vue?vue&type=style&index=0&id=212a8f00&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-212a8f00"]])

export default __exports__